import { render, staticRenderFns } from "./shipments-filters.vue?vue&type=template&id=17aba418&scoped=true"
import script from "./shipments-filters.vue?vue&type=script&lang=js"
export * from "./shipments-filters.vue?vue&type=script&lang=js"
import style0 from "./shipments-filters.vue?vue&type=style&index=0&id=17aba418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17aba418",
  null
  
)

export default component.exports